import { combineReducers } from 'redux';

import ids from './ids';
import idsInPages from './idsInPages';
import information from './information';
import isInserting from './isInserting';
import latestIds from './latestIds';
import positions from './positions';
import sizes from './sizes';
import target from './target';

export default combineReducers({
  ids,
  idsInPages,
  information,
  isInserting,
  latestIds,
  positions,
  sizes,
  target,
});
